<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="950px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Entitlement Setting
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Leave Entitlement Setting"
      text="Create Leave Entitlement Setting"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                v-model="leaveType"
                v-validate="'required'"
                :items="leaveTypes"
                label="Leave Type"
                :error-messages="errors.collect('leaveType')"
                data-vv-name="leaveType"   
                data-vv-as="leave type"   
                item-text="name"
                item-value="id"
              />
            </v-col>
          </v-row>
      
          <v-row>
            <v-col>
              <span class="font-weight-bold pr-2">Leave Entitlement Setting Details:</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    color="primary"
                    v-on="{ ...dialog, ...tooltip }"
                    @click="addRow"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <span>Add new row</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                type="number"
                disabled
                value="1"
                label="Start Day"
                class="example"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                type="number"
                disabled
                value="12"
                label="End Day"
                class="example"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                type="number"
                disabled
                value="8"
                label="Days"
                class="example"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                type="number"
                disabled
                value="4"
                label="Maximum Carry Forward Days"
                class="example"
              />
            </v-col>

            <v-col class="text-center">
              <span class="font-weight-bold">(EXAMPLE)</span>
            </v-col>
          </v-row>

          <v-row
            v-for="(detail,counter) in details"
            :key="counter"
          >
            <v-col class="py-0">
              <v-text-field
                v-model="detail.start_day"
                v-validate="'required|negativeValue|startDay'"
                :name="'start_day' + counter"
                :error-messages="errors.collect('start_day' + counter)"
                data-vv-delay="500"
                data-vv-as="start day"
                type="number"
                label="Start day"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                v-model="detail.end_day"
                v-validate="'required|negativeValue|endDay'"
                :name="'end_day' + counter"
                :error-messages="errors.collect('end_day' + counter)"
                data-vv-delay="500"
                data-vv-as="end day"
                type="number"
                label="End Day"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                v-model="detail.days"
                v-validate="'required|negativeValue|dayValidator'"
                :name="'days' + counter"
                :error-messages="errors.collect('days' + counter)"
                data-vv-delay="500"
                data-vv-as="days"
                type="number"
                label="Days"
              />
            </v-col>

            <v-col class="py-0">
              <v-text-field
                v-model="detail.maximum_carry_forward_days"
                v-validate="'required|negativeValue|dayValidator'"
                :name="'maximum_carry_forward_days' + counter"
                :error-messages="errors.collect('maximum_carry_forward_days' + counter)"
                data-vv-delay="500"
                data-vv-as="maximum carry forward day"
                type="number"
                label="Maximum Carry Forward Days"
              />
            </v-col>

            <v-col class="text-center">
              <v-icon
                color="error"
                @click="deleteRow(counter)"
              >
                mdi-window-close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        progressing: false,
        name: null,
        details: [ ],
        leaveTypes: [],
        leaveType: null,
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return       
        this.loadLeaveType()
        this.resetForm()
      },
    },

    mounted () {
      let _this = this

      this.$validator.extend('negativeValue', {
        getMessage (field, args) {
          return 'Invalid Number'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })

      this.$validator.extend('startDay', {
        getMessage (field, args) {
          return 'Invalid start day'
        },
        validate (value, args) {
          let valid = true
        
          for (let i = 0; i < _this.details.length; i++) {
            if (i > 0) {
              if (
                ((_this.details[i].start_day !== null) && (parseInt(_this.details[i].start_day) <= parseInt(_this.details[i - 1].start_day))) ||
                ((_this.details[i - 1].end_day !== null) && (parseInt(_this.details[i].start_day) <= parseInt(_this.details[i - 1].end_day)))
              ) {
                valid = false
                break
              }
            } 
          }
          
          return valid
        },
      })

      this.$validator.extend('endDay', {
        getMessage (field, args) {
          return 'Invalid end day'
        },
        validate (value, args) {
          let valid = true

          for (let i = 0; i < _this.details.length; i++) {
            if (i > 0) {
              if (
                (_this.details[i - 1].end_day !== null && (parseInt(_this.details[i].end_day) < parseInt(_this.details[i].start_day))) ||
                (_this.details[i].start_day !== null && (parseInt(_this.details[i].end_day) <= parseInt(_this.details[i].start_day)))
              ) {
                valid = false
                break
              }
            }
          }

          return valid
        },
      })

      this.$validator.extend('dayValidator', {
        getMessage (field, args) {
          return 'Invalid days'
        },
        validate (value, args) {
          let valid = true

          for (let i = 0; i < _this.details.length; i++) {
            if (i > 0) {
              if (
                (_this.details[i - 1].days !== null && (parseInt(_this.details[i].days) < parseInt(_this.details[i - 1].days)))
              ) {
                valid = false
                break
              }
            }
          }

          return valid
        },
      })
    },

    methods: {
      submitForm () { 
        this.progressing = true
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.$api.leaveEntitlementSettings().create(this.prepareEntitlementSettingFormData())
              .then(res => {
                this.$api.leaveEntitlementSettingDetails().create(this.prepareEntitlementSettingDetailsFormData(res.data.id))
                  .then(res => {
                    this.$emit('created')
                    this.$snack({ message: 'Leave Entitlement Setting Added Successfully' })

                    this.progressing = false
                    this.dialog = false    
                  })
              })
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },

      prepareEntitlementSettingFormData () {
        return {
          name: this.name,
          leave_type_id: this.leaveType,
        }
      },

      prepareEntitlementSettingDetailsFormData (id) {
        return {
          leave_entitlement_setting_id: id,
          details: this.details,
        }
      },

      addRow () {
        this.details.push({ start_day: null, end_day: null, days: null })
      },

      deleteRow (counter) {
        this.details.splice(counter, 1)
      },

      resetForm () {
        this.$validator.reset()
        this.name = null
        this.details = []
      },

      isValidNumbers (value) {
        return value >= 0
      },

      loadLeaveType () {
        this.$api.leaveTypes().list()
          .then(res => {
            this.leaveTypes = res.data.filter(leaveType => {
              return leaveType.is_optional_leave_entitlement === 0
            })
          })
      },
    },
  }
</script>

<style>
.example.theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before{
  border:none
}
</style>
